var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-0 pa-0"},[(_vm.lineLeaderEnroll)?_c('font-awesome-layers',{staticClass:"close-icon"},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1):_c('v-icon',[_vm._v("mdi-close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }